import { messages as svMessagesUi } from '@startuptools/ui/locales/sv/messages';
import { messages as enMessagesUi } from '@startuptools/ui/locales/en/messages';
import { messages as svMessagesBusinessUi } from '@startuptools/business-ui/locales/sv/messages';
import { messages as enMessagesBusinessUi } from '@startuptools/business-ui/locales/en/messages';
import { messages as svMessages } from './locales/sv/messages';
import { messages as enMessages } from './locales/en/messages';
import { i18n } from '@lingui/core';

const _allMessages = {
  en: { ...enMessages, ...enMessagesUi, ...enMessagesBusinessUi },
  sv: { ...svMessages, ...svMessagesUi, ...svMessagesBusinessUi },
};

export const loadI18n = (locale: 'sv' | 'en') => {
  i18n.load(_allMessages);
  i18n.activate(locale);
  return i18n;
};
